import React, { useState } from 'react';

export const ImageWithFallback = ({ src, alt, firstName, lastName }: any) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => {
    setImgError(true);
  };

  const getInitials = () => {
    const firstInitial = firstName && firstName.charAt(0).toUpperCase();
    const lastInitial = lastName && lastName.charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  };

  return (
    <>
      {!imgError ? (
        <img src={src} alt={alt} onError={handleError} />
      ) : (
        <span className="medium-text font-weight-bold">{getInitials()}</span>
      )}
    </>
  );
};
